/* @flow */
import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Electron from 'lib/Electron';
import EventTracking, { getEventScreenName } from 'lib/EventTracking';
import PusherActions from 'pusher/PusherActions';
import ScrollContext from 'components/ScrollContext.jsx';
import ToastsContainerNode from 'components/ToastsContainerNode.jsx';
import userAgent from 'lib/currentUserAgent';
import WebNotificationClient from 'notifications/WebNotificationClient';
import { markNewTransition, markAppMounted } from 'lib/Timer';
import { refreshAppIfOld } from 'utils/refreshAssets';
import { registerInterceptor, unregisterInterceptor } from 'singletons/xhrInterceptors';
import Joyrides from 'app/components/Joyrides.jsx';

import styles from './styles/App.css';

import type { RouterState } from 'lib/ReactRouterTypes';

class App extends React.Component {
  static propTypes = {
    routes: React.PropTypes.array.isRequired, // eslint-disable-line
    location: React.PropTypes.object.isRequired, // eslint-disable-line
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  // XXX all of these are available on context.router now
  // TODO delete here and update all dependents
  static childContextTypes = {
    routes: React.PropTypes.array.isRequired,
    location: React.PropTypes.object.isRequired,
    params: React.PropTypes.object.isRequired,
  };

  // typecheck: ignore statement
  static onEnter(nextState: RouterState) {
    // Refresh the app if it's more than a day old when the user is navigating.
    refreshAppIfOld();

    markNewTransition(nextState.location.pathname);

    EventTracking.view(
      getEventScreenName(null, nextState),
      nextState.params);
  }

  static onChange(prevState: RouterState, nextState: RouterState) {
    window.prevLocation = prevState.location;
    App.onEnter(nextState);
  }

  // XXX all of these are available on context.router now
  // TODO delete here and update all dependents
  getChildContext() {
    return {
      routes: this.props.routes,
      location: this.props.location,
      params: this.props.params,
    };
  }

  componentDidMount() {
    markAppMounted();
    registerInterceptor('userchange-interceptor', this.userChangeInterceptor);

    this.onUserSignIn();
    CurrentUser.addSignInListener(this.onUserSignIn);
    CurrentUser.addSignInNoRoleListener(this.onUserSignIn);
    Electron.bindIfAvailable(this.context.router);
    WebNotificationClient.handleNotifications(this.context.router);
  }

  componentWillUnmount() {
    unregisterInterceptor('userchange-interceptor');
    // leave 503-interceptor, probably should move elsewhere but another PR

    CurrentUser.removeSignInListener(this.onUserSignIn);
  }

  onUserSignIn = () => {
    if (CurrentUser.isSignedIn()) {
      const user = CurrentUser.getUser();
      if (user && user.getPusherChannel()) {
        PusherActions.subscribeToChannel(user.getPusherChannel());
      }
    }
  };

  isOutOfSync = (response: Object) => {
    // TODO FIXME IE cache headers, resulting in this showing too much.
    if (userAgent.ie()) {
      return false;
    }

    const status = response.headers['status'];
    if (status && status.toLowerCase() === '304 not modified') {
      return false;
    }

    if (!CurrentUser.isSignedIn() || !response.headers['x-userid']) {
      return false;
    }

    return response.headers['x-userid'] !== CurrentUser.getUserId().toString();
  };

  // @returns whether the response was intercepted
  userChangeInterceptor = (response: Object) => {
    const isOutOfSync = this.isOutOfSync(response);
    if (!this.context.router.isActive('/user_changed') && isOutOfSync) {
      this.context.router.push('/user_changed');
      return true;
    }

    return false;
  };

  render() {
    return (
      <ScrollContext className={styles.this}>
        <ToastsContainerNode />
        <Joyrides />
        {this.props.children}
      </ScrollContext>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/components/App.jsx